export default __webpack_public_path__ + "static/media/avater2.41bd0742.png";